import React, { useEffect, useState, useRef } from "react";
import io from "socket.io-client";
import { Col, Container, Dropdown, Row, Button } from "react-bootstrap";
import OpportunityCard from "../Components/OpportunityCard";
import { Images } from "../Components/Images";
import { SOCKET_URL } from "../Config/env";
import { UseMarketsInfo } from "../Hooks/UseMarkets";
import Header from "../layout/Header";
import NewFooter from "../layout/Footer";
import { MdEdit } from "react-icons/md";
import { FaPlus } from "react-icons/fa";
import Form from "react-bootstrap/Form";
import {
  getAllExchanges,
  getAllPairs,
  getUserChooseData,
  removeExchangeData,
  removePairData,
} from "../actions/markets";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { isEmpty } from "../lib/isEmpty";
import { CURRENT_CHAIN_ID } from "../Hooks/useWeb3";
import { IoIosCloseCircleOutline } from "react-icons/io";

const Opportunities = () => {
  const { walletaddress } = useSelector((state) => state.wallet);

  const [user, setUser] = useState();
  const [color, setColor] = useState("");
  const [tradeInfo, setTradeInfo] = useState({});
  const [active, setActive] = useState(false);
  const [data, setData] = useState({});
  const [filter, setFilter] = useState();
  let chaincurrentId = CURRENT_CHAIN_ID()

  const [chainId, set_ChainId] = useState(chaincurrentId);

  const [manual, setManual] = useState(0);
  const [activeTab, setActiveTab] = useState(0);

  const [logs, setLogs] = useState([]);
  const [pairData, setPairData] = useState([]);
  const [exchangeData, setexchangeData] = useState([]);

  const [removedPairData, setremovedPairData] = useState([]);
  const [removedExchangeData, setremovedExchangeData] = useState([]);

  const [gasFeeEdit, setGasFeeEdit] = useState(false);

  const [logStatus, setLogStatus] = useState(true)

  const inputRef = useRef(null);

  const [autoRunningContent, setAutoRunningContent] = useState([
    {
      value: "Buy: PancakeSwapV2 => 0.9974910593978679",
    },
    {
      value:
        "Sell: Ape Swap => 0.9989918392146737Simulating arbitrage opportunity...",
    },
    {
      value:
        "BUSD-USDT Simulating arbitrage opportunity... BUSD-USDT Simulating arbitrage opportunity...",
    },
    {
      value: "ETH-WBNB Buy: SushiSwapV2 => 0.9863660566693824",
    },
    {
      value: "Sell: PancakeSwapV2 => 0.9974910593978679",
    },
    {
      value: "Buy: SushiSwapV2 => 0.983416692241866",
    },
    {
      value: "Buy: PancakeSwapV2 => 0.9974910593978679",
    },
    {
      value:
        "Sell: Ape Swap => 0.9989918392146737Simulating arbitrage opportunity...",
    },
    {
      value:
        "BUSD-USDT Simulating arbitrage opportunity... BUSD-USDT Simulating arbitrage opportunity...",
    },
    {
      value: "ETH-WBNB Buy: SushiSwapV2 => 0.9863660566693824",
    },
    {
      value: "Sell: PancakeSwapV2 => 0.9974910593978679",
    },
    {
      value: "Buy: SushiSwapV2 => 0.983416692241866",
    },
    {
      value: "Buy: PancakeSwapV2 => 0.9974910593978679",
    },
    {
      value:
        "Sell: Ape Swap => 0.9989918392146737Simulating arbitrage opportunity...",
    },
    {
      value:
        "BUSD-USDT Simulating arbitrage opportunity... BUSD-USDT Simulating arbitrage opportunity...",
    },
    {
      value: "ETH-WBNB Buy: SushiSwapV2 => 0.9863660566693824",
    },
    {
      value: "Sell: PancakeSwapV2 => 0.9974910593978679",
    },
    {
      value: "Buy: SushiSwapV2 => 0.983416692241866",
    },
    {
      value: "Buy: PancakeSwapV2 => 0.9974910593978679",
    },
    {
      value:
        "Sell: Ape Swap => 0.9989918392146737Simulating arbitrage opportunity...",
    },
    {
      value:
        "BUSD-USDT Simulating arbitrage opportunity... BUSD-USDT Simulating arbitrage opportunity...",
    },
    {
      value: "ETH-WBNB Buy: SushiSwapV2 => 0.9863660566693824",
    },
    {
      value: "Sell: PancakeSwapV2 => 0.9974910593978679",
    },
    {
      value: "Buy: SushiSwapV2 => 0.983416692241866",
    },
  ]);

  // useEffect(() => {
  //   set_ChainId(CHAINS[localStorage?.CHAIN]?.CHAIN_ID);
  // }, [localStorage?.CHAIN]);

  useEffect(() => {
    set_ChainId(CURRENT_CHAIN_ID())
  }, [localStorage?.CHAIN]);

  useEffect(() => {
    UseMarketsInfo().then((info) => {
      console.log("info........", info, chainId);
      const filteredinfo = Object.fromEntries(
        Object.entries(info).filter(([key, value]) => value.chainId === chainId)
      );
      console.log("info11........", filteredinfo);

      setData(filteredinfo);
      // handleFillter();
    });
    const socket = io(SOCKET_URL, { transports: ["polling"] });


    const handleMessage = throttle((message) => {

      console.log("arbiInfoarbiInfo", message);

      message = JSON.parse(message);
      console.log("handleMessage : ", message, message.chainId);
      let colors = "";
      setColor((colorss) => (colors = colorss));
      // setData((datas) => {
      //   datas[message?.symbol] = { ...message, color: colors };
      //   console.log("Set data", datas, datas[message?.symbol]);
      //   return datas;
      // });
      setData((datas) => {
        if (chainId === message.chainId) {
          return {
            ...datas,
            [message?.symbol]: { ...message, color: colors },
          };
        } else {
          return datas;
        }
      });

      setTimeout(() => setColor(getRandomColor()), 3000);

      setLogs((logss) => {
        console.log("LOGS>>>> : ", logss);
        logss.push({
          id: message.id,
          logs: message.logs,
          color: color,
        });
        return logss.reverse();
      });
    }, 1000);

    socket.on("arbiInfo", (message) => handleMessage(message));
    socket.on("adminlog", (message) => handleMessage(message));

    socket.on("connect", () => {
      setActive(true);
    });

    socket.on("disconnect", () => {
      setActive(false);
    });
    return () => {
      socket.disconnect();
    };
  }, [localStorage?.CHAIN]);

  const handleFillter = (type) => {
    console.log(type, "type++++++++++++++");

    if (type == "All") {
    }

    const res = {};
    let arr = Object.keys(data);
    let done = false;
    while (!done) {
      done = true;
      for (let i = 0; i < arr.length; i += 1) {
        let aData = parseFloat(data[arr[i]]?.difference.split("%")[0]);
        let cData = parseFloat(data[arr[i - 1]]?.difference.split("%")[0]);
        if (type == "High to Low") {
          if (cData < aData) {
            done = false;
            let tmp = arr[i - 1];
            arr[i - 1] = arr[i];
            arr[i] = tmp;
          }
        }
        if (type == "Low to High") {
          if (cData > aData) {
            done = false;
            let tmp = arr[i - 1];
            arr[i - 1] = arr[i];
            arr[i] = tmp;
          }
        }
      }
    }
    arr.forEach((key) => {
      res[key] = data[key];
    });
    setData(res);
  };

  function getRandomColor() {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  const throttle = (func, limit) => {
    let inThrottle;
    return function () {
      const context = this,
        args = arguments;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  };

  const colors = ["red", "green", "yellow", "purple", "#00ddeb"];

  useEffect(() => {
    console.log("Logsssss");
    getPairs();
    getExchanges();
    getUserData();
  }, [logs, chainId]);

  useEffect(() => {
    let userData = sessionStorage.getItem("user");
    userData = JSON.parse(userData);
    setUser(userData);
  }, []);

  const getPairs = async () => {
    try {
      let { status, message, result } = await getAllPairs({
        chainId: CURRENT_CHAIN_ID()
      });
      setPairData(result);
    } catch (err) {
      console.log(err, "ERR");
    }
  };

  const getExchanges = async () => {
    try {
      let { status, message, result } = await getAllExchanges({
        chainId: CURRENT_CHAIN_ID()
      });
      console.log("getExchanges", result);

      setexchangeData(result);
    } catch (err) {
      console.log(err, "ERR");
    }
  };

  const getUserData = async () => {
    try {
      let { status, message, result } = await getUserChooseData({
        userId: user?._id,
      });
      console.log(status, message, result, "status, message, result")
      setremovedPairData(result.pairs);
      setremovedExchangeData(result.exchanges);
    } catch (err) {
      console.log(err, "ERR");
    }
  };
  const removePair = async (e, pairId) => {
    try {
      console.log(e.target.checked, "VALUE")
      let { status, message, result } = await removePairData({
        status: e.target.checked,
        pairId: pairId,
        userId: user._id,
        walletAddress: walletaddress,
      });
      if (status == "success") {
        toast.success("Status Changed Successfully");
        getUserData();
      } else {
        toast.error("Status Changed Failed!");
      }
    } catch (err) {
      console.log(err, "ERR");
    }
  };
  const removeExchange = async (e, exchangeId) => {
    try {
      let { status, message, result } = await removeExchangeData({
        exchangeId: exchangeId,
        userId: user._id,
        walletAddress: walletaddress,
        status: e.target.checked
      });
      if (status == "success") {
        toast.success("Removed Successfully");
        getUserData();
      } else {
        toast.error("Removed Failed!");
      }
    } catch (err) {
      console.log(err, "ERR");
    }
  };

  const handleEditable = () => {
    inputRef.current.focus();
    setGasFeeEdit(true);
  };

  useEffect(() => {
    if (gasFeeEdit) {
      inputRef.current.focus();
    }
  }, [gasFeeEdit]);

  const handleGasFeeSubimt = () => {
    setGasFeeEdit(false);
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <div className="common_bgVideo opportunities_page">
        {/* <video
          src={Images.bannerBg_vdo}
          autoPlay
          muted
          loop
          className="img-fluid video_src"
        />
        <div className="overlay_bg" /> */}

        {/* <img
          src={Images.planlftOvly}
          className="opportunity__lftBlur img-fluid"
        /> */}
        {/* <img
          src={Images.planrytOvly}
          className="opportunity__rightBlur img-fluid"
        /> */}
        <Header />
        <Container
          fluid
          className="p-0 custom_container"
        >
          <Container className="home__indexAligner innerpages_ui">
            <div className="plans__holder">
              <h4 className="m-0 hebrew_bold opportunity__title">
                Market Opportunities
              </h4>
              <p className="plans__titleHint m-0 hebrew_font position-relative mt-2">
                Explore real-time arbitrage opportunities across supported DEXs and token pairs.
              </p>
              <div className="text-end my-3">
                <Dropdown
                  className="cmn_filterDrop"
                  onSelect={(type) => {
                    handleFillter(type);
                  }}
                >
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    <i class="fa-solid fa-arrow-down-wide-short" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="cmn_filterDropMenu">
                    <Dropdown.Item eventKey={"All"}>All</Dropdown.Item>
                    <Dropdown.Item eventKey={"High to Low"}>
                      High to Low
                    </Dropdown.Item>
                    <Dropdown.Item eventKey={"Low to High"}>
                      Low to High{" "}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className={
                manual
                  ? "manual market_opportunityTab"
                  : "automatic market_opportunityTab"
              }
              >
                <div className="header_sec">
                  <Button
                    className={
                      manual == 0 ? "tabButton active" : "tabButton"
                    }
                    onClick={() => setManual(0)}
                  >
                    Manual
                  </Button>
                  <Button
                    className={
                      manual == 1 ? "active tabButton" : "tabButton"
                    }
                    onClick={() => setManual(1)}
                  >
                    Automatic
                  </Button>
                </div>

                <div className="tabs_cnts">
                  {manual == 0 ? (
                    <div className="tab_bdr">
                      <div className="manual_cards">
                        <Row className="">
                          {Object.keys(data).length > 0 &&
                            Object.keys(data).map((item, index) => (
                              <Col lg={3} md={4} sm={6} className="mb-4">


                                <OpportunityCard data={data[item]} />
                              </Col>
                            ))}
                        </Row>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="automatic_opport tab_bdr">
                        <div className="head_sec">
                          <Button className="start_stopBtn cmn_blueBtn"
                            onClick={(e) => {
                              setLogStatus(false);
                              toast.success('Bot Stopped')
                            }}
                          >
                            Stop
                          </Button>
                          <Button className="start_stopBtn cmn_blueBtn"
                            onClick={(e) => {
                              setLogStatus(true);
                              toast.success('Bot Started')
                            }}

                          >
                            Start
                          </Button>
                        </div>
                        <div className="autoRunning_cnt">
                          {logStatus && logStatus == true && logs.map((item, index) => {
                            return (
                              <p
                                className="cnt_txt"
                                style={{ color: colors[index % colors.length] }}

                              >
                                {item.logs}
                              </p>
                            );
                          })}
                        </div>
                      </div>
                      <div className="foot_cardSec">
                        <div className="tabs_heading">
                          {/* <Button
                            className={
                              activeTab == 0 ? "title_btn active" : "title_btn"
                            }
                            onClick={() => setActiveTab(0)}
                          >
                            Gas Fee
                          </Button> */}
                          <Button
                            className={
                              activeTab == 0 ? "title_btn active" : "title_btn"
                            }
                            onClick={() => {
                              setActiveTab(0); getUserData()
                            }
                            }
                          >
                            Pairs
                          </Button>
                          <Button
                            className={
                              activeTab == 1 ? "title_btn active" : "title_btn"
                            }
                            onClick={() => {
                              setActiveTab(1); getUserData()
                            }
                            }
                          >
                            Exchange
                          </Button>
                        </div>

                        {/* {activeTab == 0 ? (
                          <div className="content">
                            <p className="title_txt mb-0">Gas Fee</p>
                            <div className="gas_feeInp">
                              <div className="posi_rel position-relative">
                                <input
                                  ref={inputRef}
                                  type="text"
                                  class="fee_input position-relative hebrew_font"
                                  placeholder="Gas Fee"
                                  disabled={gasFeeEdit ? false : true}
                                />
                                <button
                                  class="edit_btn"
                                  onClick={handleEditable}
                                >
                                  <span className="btn_icon">
                                    <MdEdit className="icon" />
                                  </span>
                                  Edit
                                </button>
                              </div>
                            </div>
                            <div className="btn_sec">
                              <Button
                                className="submit_btn cmn_blueBtn primary_grad_btn"
                                onClick={handleGasFeeSubimt}
                              >
                                Submit
                              </Button>
                              <Button className="clear_btn cmn_blueBdr_btn">
                                Clear
                              </Button>
                            </div>
                          </div>
                        ) : */}

                        {activeTab == 0 ? (
                          <div className="content">
                            <p className="title_txt mb-0">Pairs</p>
                            {/* <div className="pairs_items">
                              <div className="pairs_icons ">
                                <div className="icons">
                                  <img
                                    src={Images.icon1}
                                    className="icon_src"
                                  />
                                  <span className="plus">
                                    <FaPlus />
                                  </span>
                                  <img
                                    src={Images.icon2}
                                    className="icon_src"
                                  />
                                </div>
                                <button class="remove_btn">
                                  <span className="btn_icon">
                                    <IoClose className="icon" />
                                  </span>
                                  Remove
                                </button>
                              </div>
                            </div> */}
                            <div className="pairs_items">
                              { /* <div className="row"> */}
                              {pairData && pairData.length > 0
                                ? pairData.map((item) => {
                                  let findPairItem = removedPairData.find(
                                    (item1) => item1 == item._id
                                  );

                                  console.log(findPairItem, "findPairItem")

                                  // if (isEmpty(findPairItem)) {
                                  return (
                                    // <div className="col-12 col-sm-6 col-xl-4 custom_col">
                                    <div className="pairs_icons">
                                      <div className="icons">
                                        {/* {item.symbol} */}
                                        <img
                                          src={item.token1.logoURI}
                                          className="icon_src"
                                        />
                                        <span className="plus">
                                          <FaPlus />
                                        </span>
                                        <img
                                          src={item.token2.logoURI}
                                          className="icon_src"
                                        />
                                      </div>

                                      <Form.Check
                                        type="switch"
                                        className="remove_toggleBtn"
                                        checked={isEmpty(findPairItem) ? false : true}
                                        onClick={(e) => removePair(e, item._id)}
                                      />

                                      {/* <button
                                        class="remove_btn"
                                        onClick={(e) => removePair(e, item._id)}
                                      >
                                        <span className="btn_icon">
                                          <IoIosCloseCircleOutline className="icon" />
                                        </span>
                                        Remove
                                      </button> */}

                                    </div>

                                    // </div>
                                  );
                                  // }
                                })
                                : ""}
                            </div>
                          </div>
                        ) : (
                          // </div>
                          <div className="content">
                            <p className="title_txt mb-0">Exchanges</p>
                            <div className="exchange">
                              {console.log("exchangeData", exchangeData)}

                              {exchangeData && exchangeData.length > 0
                                ? exchangeData.map((item) => {
                                  let findExchangeItem =
                                    removedExchangeData.find(
                                      (item1) => item1 == item._id
                                    );
                                  console.log(findExchangeItem,
                                    isEmpty(findExchangeItem),
                                    "findExchangeItem"
                                  );
                                  // if (isEmpty(findExchangeItem)) {
                                  return (
                                    <div className="item">
                                      <div className="icons">
                                        <img
                                          src={item?.logoURI}
                                          className="icon_src"
                                        />

                                      </div>
                                      {/* <button
                                            class="remove_btn"
                                            onClick={() =>
                                              removeExchange(item._id)
                                            }
                                          >
                                            <span className="btn_icon">
                                              <IoClose className="icon" />
                                            </span>
                                            Remove
                                          </button> */}
                                      {/* <Form.Check
                                        type="switch"
                                        className="remove_toggleBtn"
                                        checked={isEmpty(findExchangeItem) ? false : true}
                                        onClick={(e) =>
                                          removeExchange(e, item._id)
                                        }

                                      /> */}

                                      {/* <button
                                        class="remove_btn"
                                        onClick={(e) => removeExchange(e, item._id)}
                                      >
                                        <span className="btn_icon">
                                          <IoIosCloseCircleOutline className="icon" />
                                        </span>
                                        Remove
                                      </button> */}
                                      <Form.Check
                                        type="switch"
                                        className="remove_toggleBtn"
                                        checked={isEmpty(findExchangeItem) ? false : true}
                                        onClick={(e) =>
                                          removeExchange(e, item._id)
                                        }

                                      />

                                    </div>
                                  );
                                  // }
                                })
                                : ""}
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </Container>
        </Container>
      </div >
      <NewFooter />
    </>
  );
};

export default Opportunities;
